import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ACTION_TYPES from "common/utils/actionTypes";
import CardHolderAddModalForm from "../CardHolderAddModal.Form/CardHolderAddModal.Form";
import CardHolderEditModalForm from "../CardHolderEditModal.Form/CardHolderEditModal.Form";
import { Alert } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

const AddModal = ({
  showModal,
  confirmModal,
  hideModal,
  type,
  list,
  item,
  input,
  loading,
  apiErrors,
  moduleName,
}) => {
  const userName = item ? " " + item.card_holder_full_name : "";
  const subject = "card holder";
  const { t } = useTranslation("LocalAdminPanel");
  return (
    <>
      <Modal show={showModal} onHide={hideModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {type === ACTION_TYPES.ADD
              ? "Add new " + subject
              : type === ACTION_TYPES.DELETE
              ? "Are you sure?"
              : type === ACTION_TYPES.EDIT
              ? "Edit " + userName
              : type === ACTION_TYPES.VIEW
              ? capitalize(subject) + " details"
              : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {type === ACTION_TYPES.ADD ? (
            <CardHolderAddModalForm
              item={item}
              list={list}
              action={type}
              handleOnSubmit={confirmModal}
              loading={loading}
              apiErrors={apiErrors}
              moduleName={moduleName}
            />
          ) : type === ACTION_TYPES.DELETE ? (
            <>
              {t("you_will_delete")} {subject}{" "}
              <strong>
                {item.card_holder_full_name} (id: {item.id})
              </strong>
            </>
          ) : ACTION_TYPES.EDIT ? (
            <CardHolderEditModalForm
              item={item}
              list={list}
              action={type}
              handleOnSubmit={confirmModal}
              loading={loading}
              apiErrors={apiErrors}
              moduleName={moduleName}
            />
          ) : null}
          {apiErrors?.length ? (
            <Alert className="my-2" variant="danger">
              {apiErrors}
            </Alert>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          {type === ACTION_TYPES.ADD || type === ACTION_TYPES.EDIT ? (
            <Button
              variant="primary"
              disabled={loading}
              form={list + "-" + type + "-modal-form"}
              type="submit"
              className="w-25"
            >
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                t("buttons.confirm")
              )}
            </Button>
          ) : type === ACTION_TYPES.DELETE ? (
            <Button
              variant="primary"
              onClick={() => confirmModal(ACTION_TYPES.DELETE, item)}
              disabled={loading}
            >
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                t("buttons.confirm")
              )}
            </Button>
          ) : null}
          {type === ACTION_TYPES.VIEW ? (
            <Button
              variant="secondary"
              onClick={hideModal}
              disabled={loading}
              className="w-25 mx-auto"
            >
              {t("buttons.close")}
            </Button>
          ) : (
            <Button
              variant="secondary"
              onClick={hideModal}
              disabled={loading}
              className="w-25"
            >
              {t("buttons.cancel")}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddModal;
